import { isEqual, uniqueId } from 'lodash';
import createChainedFunction from 'utils/createChainedFunction';
import cx from 'classnames';
import DatePickerInput from 'components/DatePickerInput.jsx';
import Field from 'components/Field.jsx';
import Formsy from 'lib/Formsy';
import Label from 'components/Label.jsx';
import React from 'react';

import 'components/styles/FormDatePickerInput.scss';

export default React.createClass({
  propTypes: {
    label: React.PropTypes.node,
    labelHidden: React.PropTypes.bool,
    showErrorAfterBlur: React.PropTypes.bool,
    showErrorOnPristine: React.PropTypes.bool,
  },

  mixins: [Formsy.Mixin],

  getDefaultProps() {
    return {
      showErrorAfterBlur: false,
    };
  },

  getInitialState() {
    return {
      wasBlur: false,
      value: this.props.value,
    };
  },

  componentWillMount() {
    this.id = uniqueId('id-');
  },

  componentDidMount() {
    if (this.props.value) {
      this.onChange(this.props.value);
    }
  },

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !isEqual(this.props, nextProps) ||
      !isEqual(this.state, nextState)
    );
  },

  onChange(value) {
    this.setState({ value });
    this.setValue(value);
  },

  onBlur() {
    if (this.state.wasBlur === false) {
      this.setState({ wasBlur: true });
    }
  },

  renderLabel() {
    const { label } = this.props;

    if (label) {
      return (
        <Label htmlFor={this.id} hidden={this.props.labelHidden}>
          {label}
        </Label>
      );
    } else {
      return null;
    }
  },

  render() {
    let error = this.getErrorMessage();

    if (this.props.showErrorAfterBlur && !this.state.wasBlur) {
      error = null;
    }

    return (
      <Field className="FormDatePickerInput" error={error}>
        {this.renderLabel()}
        <DatePickerInput
          {...this.props}
          value={this.state.value}
          className={cx(this.props.className,
            'FormDatePickerInput-input', {
              'FormDatePickerInput-input-error': !!error,
            }
          )}
          onBlur={createChainedFunction(this.props.onBlur, this.onBlur)}
          onChange={createChainedFunction(this.props.onChange, this.onChange)}
        />
      </Field>
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/FormDatePickerInput.jsx